import React from "react";

const DevNote = ({ children }) => {
  const ENV = import.meta.env.VITE_APP_ENV || "local";
  return (
    ENV === "local" && (
      <div className="bg-slate-50 border-2 border-red-600 m-10  p-10 flex flex-col gap-9">
        <h4>Dev Note</h4>
        <div>{children}</div>
      </div>
    )
  );
};

export default DevNote;
